import ArticleCard from '../compnents/cards/ArticleCard';

const courses = [
	{
		title: 'Math For Machine Learning',
		subtitle: 'دورة Math for Machine Learning تمهد إلى تعليم الأساسيات ',
		instructor: 'Ahmed Ashraf',
		img: '/images/about.png',
		path: '/courses/2',
	},
	{
		title: 'Math For Machine Learning',
		subtitle: 'دورة Math for Machine Learning تمهد إلى تعليم الأساسيات ',
		instructor: 'Ahmed Ashraf',
		img: '/images/about.png',
		path: '/courses/3',
	},
	{
		title: 'Math For Machine Learning',
		subtitle: 'دورة Math for Machine Learning تمهد إلى تعليم الأساسيات ',
		instructor: 'Ahmed Ashraf',
		img: '/images/about.png',
		path: '/courses/4',
	},
	{
		title: 'Math For Machine Learning',
		subtitle: 'دورة Math for Machine Learning تمهد إلى تعليم الأساسيات ',
		instructor: 'Ahmed Ashraf',
		img: '/images/about.png',
		path: '/courses/5',
	},
];
export default function AICoursePath() {
	return (
		<section className='bg-transparent text-gray-800 py-12 px-6 md:px-12 mt-24'>
			{/* العنوان */}
			<div className='text-center mb-12'>
				<h2 className='text-3xl font-bold text-blue-500 mb-4'>
					مسار الذكاء الاصطناعي
				</h2>
				<p className='text-gray-800'>
					ابدأ من أول مرحلة وامشي بالتسلسل، وخلص الكورسات والتدريبات والمشاريع
					المطلوبة
				</p>
			</div>

			{/* صورة المسار (سلم الكورسات) */}
			<div className='flex justify-center mb-12'>
				<img
					src='/images/10.png'
					alt='AI Path'
					className='max-w-4xl'
				/>
			</div>

			<div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
				{courses.map((item, index) => (
					<ArticleCard
						title={item.title}
						description={item.subtitle}
						image={item.img}
						instructor={item.instructor}
						path={item.path}
					/>
				))}
			</div>
		</section>
	);
}
